import React, { Component } from 'react'
import { client } from '../../../lib/environment'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Charity from './Charity'
import Content from '../../ui/Content'
import Error from '../../ui/Error'
import Loading from '../../ui/Loading'
import Section from '../../ui/Section'

class FeaturedCharities extends Component {
  constructor () {
    super()
    this.state = {
      status: 'fetching',
      data: []
    }
  }

  componentDidMount () {
    this.fetchCharities()
      .then((data) => this.setState({ status: 'fetched', data }))
      .catch((err) => console.log(err) || this.setState({ status: 'failed' }))
  }

  fetchCharities () {
    const { items = [] } = this.props

    return client.get('/api/v2/charities', {
      params: {
        ids: items.map((item) => item.charity).join(',')
      }
    })
    .then((response) => response.data.charities)
  }

  render () {
    const {
      alignment,
      backgroundImage,
      background,
      copy,
      copyAlignment,
      classNames,
      foreground,
      layout,
      size,
      spacing,
      subtitle,
      title,
      titleForeground
    } = this.props

    const {
      data,
      status
    } = this.state

    return (
      <Section
        alignment={alignment}
        backgroundImage={backgroundImage}
        background={background}
        foreground={foreground}
        size={size}
        spacing={spacing}>

        <Content
          copy={copy}
          copyAlignment={copyAlignment}
          layout={layout}
          subtitle={subtitle}
          title={title}
          titleForeground={titleForeground}>

          {status === 'fetching' && <Loading />}
          {status === 'failed' && <Error>There was an error loading charities</Error>}
          {status === 'fetched' && (
            <div className={classNames.root}>
              {data.map((charity, index) => (
                <Charity
                  key={index}
                  image={charity.logo_url}
                  name={charity.name}
                  url={charity.url}
                />
              ))}
            </div>
          )}

        </Content>
      </Section>
    )
  }
}

export default withStyles(styles)(FeaturedCharities)



// WEBPACK FOOTER //
// ./components/slices/FeaturedCharities/index.js